    <header class="page-head">
      <div>
        <h1 class="page-title">Billing</h1>
        <p class="page-subtitle">Manage payment details, billing address, settlements, and invoices from one place.</p>
      </div>
      <a class="btn btn-outline" routerLink="/payment-details">Open payment details page</a>
    </header>

    <section class="billing-grid">
      <div class="detail-card span-7">
        <form class="form-stack" [formGroup]="billingForm">
          <div class="input-group">
            <label for="billingName">Cardholder name</label>
            <input id="billingName" formControlName="cardholderName" />
          </div>
          <div class="input-group">
            <label for="billingCard">Card number</label>
            <input id="billingCard" formControlName="cardNumber" />
          </div>
          <div class="field-grid">
            <div class="input-group">
              <label for="billingExpiry">Expiry date (MM/YY)</label>
              <input id="billingExpiry" formControlName="expiryDate" />
            </div>
            <div class="input-group">
              <label for="billingCvv">CVV / CVC / Security code</label>
              <input id="billingCvv" formControlName="cvv" />
            </div>
          </div>
          <div class="input-group">
            <label for="billingAddress">Billing address</label>
            <textarea id="billingAddress" formControlName="billingAddress"></textarea>
          </div>

          <div class="btn-row">
            <button class="btn btn-primary" type="button">Add or update billing profile</button>
            <button class="btn btn-secondary" type="button">Settle account</button>
          </div>
        </form>
      </div>

      <aside class="detail-card span-5">
        <h2 class="section-title">Account summary</h2>
        <p class="label">Outstanding balance: R249.00</p>
        <p class="label">Next invoice date: 30 Apr 2026</p>
        <p class="label">Stored card type: {{ detectedCardType() }}</p>
      </aside>

      <div class="span-12">
        <h2 class="section-title">Current and previous invoices</h2>
        <div class="section-stack">
          <article class="invoice-card" *ngFor="let invoice of invoices">
            <div class="invoice-top">
              <div>
                <h3 class="section-title section-title-tight">{{ invoice.reference }}</h3>
                <p class="invoice-meta">{{ invoice.period }}</p>
              </div>
              <div class="inline-actions">
                <span class="status-chip">{{ invoice.status }}</span>
                <strong>{{ invoice.amount }}</strong>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
